import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import ContainerLayout from "../layouts/two-columns/container-layout";
import { retrievePageMenu } from "../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../redux/store";
import LoadingComp from "../components/re-usable/loading/loading";

const Onboarding = () => {
  const path = "Membership%2FOnboarding";
  const dispatch = useAppDispatch();
  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  // Page published check
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (RapsEuropeData[0]?.result !== undefined) {
      setIsPublished(true);
    }
  }, [RapsEuropeData]);

  if (!isPublished) return <LoadingComp />;
  // End Page published check

  return (
    <>
      <style>
        {`
            .hero .content { padding: 2vh 7vw 0 20px; }
            .hero .img { padding: 25px 0 25px 2vw; }
            .steps { color: #FAAC2E; font-size: x-large }
            .engage .row img { margin-bottom: 6px; }
             .engage .row p { margin-bottom: 25px; }
            
            
            @media only screen and (max-width: 450px) {
              .hero .img { padding: unset; }
              .hero .content { padding: 4vw; }
              .hero { background: #A8BBD3 !important; }
              .membership-value .col-md-5,.enterprise-value .col-md-2 { display: none; }
              .membership-value .col-md-3 > div { margin: unset !important; }
              .row .col-md-2 { display: none; }
            }
            .blue-card{
                padding: 20px;
                background-color: #55ADDA;
                border-radius: 5px;
            }
            @media(min-width: 451px){
                .blue-card{
                    border-radius: 0px;
                }
                .blue-card.right {
                    margin-left: -45px;
                    margin-top: 5px;
                }
                .blue-card.left {
                    margin-right: -45px;
                    margin-top: 5px;
                }
            }
            @media(min-width: 768px){
                .blue-card{
                    border-radius: 5px;
                }
                .blue-card.right {
                    margin-top: 50px;
                    margin-left: -60px;
                }
                .blue-card.left {
                    margin-top: 50px;
                    margin-right: -60px;
                }
            }
          
            @media(min-width: 1200px){
                .blue-card{
                    padding: 40px;
                }
                .blue-card.right {
                    margin-top: 80px;
                    margin-left: -70px;
                }
                .blue-card.left {
                    margin-top: 80px;
                    margin-right: -70px;
                }
            }
        `}
      </style>
      <Helmet>
        <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
      </Helmet>
      <ContainerLayout breadcrumbPath={path} isBreadcrumbPath={true} showAds={true}>
        <div dangerouslySetInnerHTML={{ __html: RapsEuropeData[0]?.result[0]?.description }}></div>
      </ContainerLayout>
    </>
  );
}

export default Onboarding
